/**
 * @Author: eleven
 * @Date: 2020-06-16 12:01:30
 * @Last Modified by: eleven
 * @Last Modified time: 2020-06-16 12:01:30
 * @description 各个模版的默认数据，在切换模版的时候，需要复原
 */

import { menuNavigationIconMap, shopDecorationImagesResourceBaseUrl, pathTypeMap } from '@/config/resourcesConstants'
import { getRandomString } from '@/untils/util'

/**
 * @description 各个模块与模块组件映射关系
 * @author eleven
 */
export const eachModuleToComponentMap = {
  shopInfoModule: 'fs-shop-info-module',
  imageModule: 'fs-image-module',
  menuNavigationModule: 'fs-menu-navigation-module',
  couponModule: 'fs-coupon-module',
  memberModule: 'fs-member-module',
  limitedTimeActivityModule: 'fs-limited-time-activity-module',
  goodsModule: 'fs-goods-module',
  groupBuyModule: 'fs-group-module'
}

/**
 * @description 每一个菜单导航类型的默认数据
 * @author eleven
 */
export let eachMenuNavigationModuleTypeDefaultData = {
  selfReceiveAndTakeawayType: {
    name: 'selfReceiveAndTakeawayType',
    pathList: [
      {
        menuIcon: `${shopDecorationImagesResourceBaseUrl}/self_receive_icon.png`, // 菜单图标链接
        menuName: '自提', // 菜单名称
        id: 'mention',
        type: pathTypeMap.deliveryType.type, // 跳转路径类型
        name: '点单页面自提模式' // 菜单链接名称
      },
      {
        menuIcon: `${shopDecorationImagesResourceBaseUrl}/takeaway_icon.png`, // 菜单图标链接
        menuName: '外送', // 菜单名称
        id: 'takeout',
        type: pathTypeMap.deliveryType.type, // 跳转路径类型
        name: '点单页面外送模式' // 菜单链接名称
      }
    ]
  },
  fiveClassificationType: {
    name: 'fiveClassificationType',
    pathList: [
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM1, // 菜单图标链接
        menuName: '新鲜水果', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM2, // 菜单图标链接
        menuName: '蔬菜豆品', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM3, // 菜单图标链接
        menuName: '肉禽蛋', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM4, // 菜单图标链接
        menuName: '水产海鲜', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM5, // 菜单图标链接
        menuName: '安心乳品', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      }
    ]
  },
  tenClassificationType: {
    name: 'tenClassificationType',
    pathList: [
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM1, // 菜单图标链接
        menuName: '新鲜水果', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM2, // 菜单图标链接
        menuName: '蔬菜豆品', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM3, // 菜单图标链接
        menuName: '肉禽蛋', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM4, // 菜单图标链接
        menuName: '水产海鲜', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM5, // 菜单图标链接
        menuName: '安心乳品', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM6, // 菜单图标链接
        menuName: '米面粮油', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM7, // 菜单图标链接
        menuName: '饮料冲调', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM8, // 菜单图标链接
        menuName: '休闲食品', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM9, // 菜单图标链接
        menuName: '日用清洁', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      },
      {
        menuIcon: menuNavigationIconMap.MENU_ICON_ITEM10, // 菜单图标链接
        menuName: '方便速食', // 菜单名称
        id: '', // 选中项id，goodsId、categoryId或者activityId
        type: '', // 跳转路径类型
        name: '' // 菜单链接名称
      }
    ]
  }
}

/**
 * @description 基础模版的默认数据
 * @author eleven
 */
export let basicTemplateDefaultData = [
  {
    moduleId: `shopInfoModule_${getRandomString()}`, // 模版id
    moduleName: '门店信息模块', // 模版名称
    storeName: '', // 门店名称
    storeLogo: `${shopDecorationImagesResourceBaseUrl}/icon-mendian.png`, // 门店logo
    announcementContent: '欢迎光临本店~' // 公告内容
  },
  {
    moduleId: `imageModule_${getRandomString()}`, // 模版id
    moduleName: '图片模块', // 模版名称
    showType: 'onePerLine', // 展示类型:轮播：'slider'、一行一个：'onePerLine'
    imageSize: '', // 图片宽高比：16:9、10:3
    pathList: [{ // 图片列表
      imageUrl: `https://lifecircle-ark-public.oss-cn-hangzhou.aliyuncs.com/fubeimina/img-fruit.png`, // 图片地址
      id: '', // 选中项id，goodsId、categoryId或者activityId
      type: '', // 跳转的小程序链接类型
      name: '' // 跳转的小程序链接名称
    }]
  },
  {
    moduleId: `couponModule_${getRandomString()}`, // 模版id
    moduleName: '优惠券模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/coupon_img.png` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `memberModule_${getRandomString()}`, // 模版id
    moduleName: '会员模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/member_img.png` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `groupBuyModule_${getRandomString()}`, // 模版id
    moduleName: '团购接龙', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/basic_template_group_buy_img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `limitedTimeActivityModule_${getRandomString()}`, // 模版id
    moduleName: '显示特价模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/basic_template__limited_time_activity_module_default__img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `goodsModule_${getRandomString()}`, // 模版id
    moduleName: '商品模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/basic_template_goods_module_default__img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  }
]

/**
 * @description 餐饮模版的默认数据
 * @author eleven
 */
export let foodTemplateDefaultData = [
  {
    moduleId: `shopInfoModule_${getRandomString()}`, // 模版id
    moduleName: '门店信息模块', // 模版名称
    storeName: '', // 门店名称
    storeLogo: `${shopDecorationImagesResourceBaseUrl}/icon-mendian.png`, // 门店logo
    announcementContent: '新品尝鲜蜀地的味道，线上点单有优惠免外送费啦～' // 公告内容
  },
  {
    moduleId: `imageModule_${getRandomString()}`, // 模版id
    moduleName: '图片模块', // 模版名称
    showType: 'onePerLine', // 展示类型:轮播：'slider'、一行一个：'onePerLine'
    imageSize: '', // 图片宽高比：16:9、10:3
    pathList: [{ // 图片列表
      imageUrl: `${shopDecorationImagesResourceBaseUrl}/food_template_image_module_default_img1.jpg?v=1.0.0`, // 图片地址
      id: '', // 选中项id，goodsId、categoryId或者activityId
      type: '', // 跳转的小程序链接类型
      name: '' // 跳转的小程序链接名称
    }]
  },
  {
    moduleId: `couponModule_${getRandomString()}`, // 模版id
    moduleName: '优惠券模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/coupon_img.png` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `memberModule_${getRandomString()}`, // 模版id
    moduleName: '会员模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/member_img.png` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `groupBuyModule_${getRandomString()}`, // 模版id
    moduleName: '团购接龙', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/food_template_group_buy_img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `limitedTimeActivityModule_${getRandomString()}`, // 模版id
    moduleName: '显示特价模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/tea_template__limifood_time_activity_module_default__img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `imageModule_${getRandomString()}`, // 模版id
    moduleName: '图片模块', // 模版名称
    showType: 'slider', // 展示类型:轮播：'slider'、一行一个：'onePerLine'
    imageSize: '10:3', // 图片宽高比：16:9、10:3
    pathList: [{ // 图片列表
      imageUrl: `${shopDecorationImagesResourceBaseUrl}/food_template_image_module_default_img2.jpg?v=1.0.0`, // 图片地址
      id: '', // 选中项id，goodsId、categoryId或者activityId
      type: '', // 跳转的小程序链接类型
      name: '' // 跳转的小程序链接名称
    }]
  },
  {
    // 商品模块需要单独动态配置 并且不跟模版相互绑定 所以无法通过此配置设置 单独在组件内部实现
    moduleId: `goodsModule_${getRandomString()}`, // 模版id
    moduleName: '商品模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/food_template_goods_module_default__img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  }
]

/**
 * @description 基础模版默认数据
 * @author eleven
 */
export let freshTemplateDefaultData = [
  {
    moduleId: `shopInfoModule_${getRandomString()}`, // 模版id
    moduleName: '门店信息模块', // 模版名称
    storeName: '', // 门店名称
    storeLogo: `${shopDecorationImagesResourceBaseUrl}/icon-mendian.png`, // 门店logo
    announcementContent: '新品上市优惠抢购中～' // 公告内容
  },
  {
    moduleId: `imageModule_${getRandomString()}`, // 模版id
    moduleName: '图片模块', // 模版名称
    showType: 'slider', // 展示类型:轮播：'slider'、一行一个：'onePerLine'
    imageSize: '16:9', // 图片宽高比：16:9、10:3
    pathList: [{ // 图片列表
      imageUrl: `${shopDecorationImagesResourceBaseUrl}/fresh_template_image_module_default_img.jpg`, // 图片地址
      id: '', // 选中项id，goodsId、categoryId或者activityId
      type: '', // 跳转的小程序链接类型
      name: '' // 跳转的小程序链接名称
    },
    { // 图片列表
      imageUrl: `${shopDecorationImagesResourceBaseUrl}/fresh_template_image_module_default_banner_img.jpg`, // 图片地址
      id: '', // 选中项id，goodsId、categoryId或者activityId
      type: '', // 跳转的小程序链接类型
      name: '' // 跳转的小程序链接名称
    }]
  },
  {
    moduleId: `menuNavigationModule_${getRandomString()}`, // 模版id
    moduleName: '宫格导航模块', // 模版名称
    moduleType: eachMenuNavigationModuleTypeDefaultData.tenClassificationType.name, // 模块类型：自提与外送：‘selfReceiveAndTakeawayType’、五宫格：‘fiveClassificationType’、十宫格：‘tenClassificationType’
    pathList: eachMenuNavigationModuleTypeDefaultData.tenClassificationType.pathList
  },
  {
    moduleId: `couponModule_${getRandomString()}`, // 模版id
    moduleName: '优惠券模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/coupon_img.png` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `memberModule_${getRandomString()}`, // 模版id
    moduleName: '会员模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/member_img.png` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `imageModule_${getRandomString()}`, // 模版id
    moduleName: '图片模块', // 模版名称
    showType: 'slider', // 展示类型:轮播：'slider'、一行一个：'onePerLine'
    imageSize: '10:3', // 图片宽高比：16:9、10:3
    pathList: [{ // 图片列表
      imageUrl: `${shopDecorationImagesResourceBaseUrl}/fresh_template_image_module_default_banner_img1.jpg`, // 图片地址
      id: '', // 选中项id，goodsId、categoryId或者activityId
      type: '', // 跳转的小程序链接类型
      name: '' // 跳转的小程序链接名称
    }]
  },
  {
    moduleId: `groupBuyModule_${getRandomString()}`, // 模版id
    moduleName: '团购接龙', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/fresh_template_group_buy_img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `limitedTimeActivityModule_${getRandomString()}`, // 模版id
    moduleName: '显示特价模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/fresh_template_limited_time_activity_module_default__img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    // 商品模块需要单独动态配置 并且不跟模版相互绑定 所以无法通过此配置设置 单独在组件内部实现
    moduleId: `goodsModule_${getRandomString()}`, // 模版id
    moduleName: '商品模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/fresh_template_goods_module_default__img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  }
]

/**
 * @description 茶饮模版的默认数据
 * @author eleven
 */
export let teaTemplateDefaultData = [
  {
    moduleId: `shopInfoModule_${getRandomString()}`, // 模版id
    moduleName: '门店信息模块', // 模版名称
    storeName: '', // 门店名称
    storeLogo: `${shopDecorationImagesResourceBaseUrl}/icon-mendian.png`, // 门店logo
    announcementContent: '健康生活，从这里开始，用最好的食材给最好的你～' // 公告内容
  },
  {
    moduleId: `imageModule_${getRandomString()}`, // 模版id
    moduleName: '图片模块', // 模版名称
    showType: 'onePerLine', // 展示类型:轮播：'slider'、一行一个：'onePerLine'
    imageSize: '', // 图片宽高比：16:9、10:3
    pathList: [{ // 图片列表
      imageUrl: `${shopDecorationImagesResourceBaseUrl}/tea_template_image_module_default_img3.jpg`, // 图片地址
      id: '', // 选中项id，goodsId、categoryId或者activityId
      type: '', // 跳转的小程序链接类型
      name: '' // 跳转的小程序链接名称
    }]
  },
  {
    moduleId: `menuNavigationModule_${getRandomString()}`, // 模版id
    moduleName: '宫格导航模块', // 模版名称
    moduleType: eachMenuNavigationModuleTypeDefaultData.selfReceiveAndTakeawayType.name, // 模块类型：自提与外送：‘selfReceiveAndTakeawayType’、五宫格：‘fiveClassificationType’、十宫格：‘tenClassificationType’
    pathList: eachMenuNavigationModuleTypeDefaultData.selfReceiveAndTakeawayType.pathList
  },
  {
    moduleId: `couponModule_${getRandomString()}`, // 模版id
    moduleName: '优惠券模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/coupon_img.png` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `memberModule_${getRandomString()}`, // 模版id
    moduleName: '会员模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/member_img.png` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `imageModule_${getRandomString()}`, // 模版id
    moduleName: '图片模块', // 模版名称
    showType: 'onePerLine', // 展示类型:轮播：'slider'、一行一个：'onePerLine'
    imageSize: '', // 图片宽高比：16:9、10:3
    pathList: [{ // 图片列表
      imageUrl: `${shopDecorationImagesResourceBaseUrl}/tea_template_image_module_default_img2.jpg`, // 图片地址
      id: '', // 选中项id，goodsId、categoryId或者activityId
      type: '', // 跳转的小程序链接类型
      name: '' // 跳转的小程序链接名称
    }]
  },
  {
    moduleId: `imageModule_${getRandomString()}`, // 模版id
    moduleName: '图片模块', // 模版名称
    showType: 'onePerLine', // 展示类型:轮播：'slider'、一行一个：'onePerLine'
    imageSize: '', // 图片宽高比：16:9、10:3
    pathList: [{ // 图片列表
      imageUrl: `${shopDecorationImagesResourceBaseUrl}/tea_template_image_module_default_img1.jpg`, // 图片地址
      id: '', // 选中项id，goodsId、categoryId或者activityId
      type: '', // 跳转的小程序链接类型
      name: '' // 跳转的小程序链接名称
    }]
  },
  {
    moduleId: `groupBuyModule_${getRandomString()}`, // 模版id
    moduleName: '团购接龙', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/tea_template_group_buy_img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    moduleId: `limitedTimeActivityModule_${getRandomString()}`, // 模版id
    moduleName: '显示特价模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/tea_template__limited_time_activity_module_default__img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  },
  {
    // 商品模块需要单独动态配置 并且不跟模版相互绑定 所以无法通过此配置设置 单独在组件内部实现
    moduleId: `goodsModule_${getRandomString()}`, // 模版id
    moduleName: '商品模块', // 模版名称
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/tea_template_goods_module_default__img.jpg` // 展示的图片，目前是写死的，用图片展示，后续再按照实际需求改数据结构
  }
]
